<div class="useful-links-section">
    <p class="useful-links-title">{{ 'IMPORTANT_LINKS' | translate }}</p>
    <div class="useful-links-scroll-container">
        <a href="https://pdmc.da.gov.in/" target="_blank" class="useful-link-card card-1">
            <img src="assets/importantLinks/pdmc-logo.png" alt="Pre Drop More Care (PDMC) Micro Irrigation" />
        </a>
        <a href="https://hid.gov.in/" target="_blank" class="useful-link-card card-2">
            <img src="assets/importantLinks/IWRD-logo.png" alt="Irrigation & Water Source Department (IWRD)" />
        </a>
        <a href="https://www.pmksy.gov.in/" target="_blank" class="useful-link-card card-3">
            <img src="assets/importantLinks/pmksy-logo.png" alt="Pradhan Mantri Krishi Sinchayee Yojana (PMKSY)" />
        </a>
        <a href="https://agriharyana.gov.in/" target="_blank" class="useful-link-card card-4">
            <img src="assets/importantLinks/agri-logo.png"
                alt="Department of Agriculture and Farmers Welfare, Haryana" />
        </a>
        <!-- <a href="https://www.mygov.in/" target="_blank" class="useful-link-card">
        <img src="assets/images/mygov-logo.png" alt="MyGov" />
      </a> -->
        <!-- <a href="https://www.makeinindia.com/" target="_blank" class="useful-link-card">
        <img src="assets/images/make-in-india-logo.png" alt="Make in India" />
      </a> -->
    </div>
</div>



<div class="contact-content mt-0 pt-2">
    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
        <div class="field sm:col-12 md:col-12 lg:col-12 my-0 py-2 mx-0 px-0 contact-heading">
            <p>{{ "CONTACT_US" | translate }}</p>
        </div>
        <div class="field sm:col-12 md:col-4 lg:col-4 my-0 py-0 mx-0 px-0">
            <div class="field sm:col-12 md:col-12 lg:col-12 my-1 py-2 mx-2 px-0 footer-info">
                <i class="pi pi-map-marker footer-icon"></i>
                <span class="footer-text">{{'BAYS_39_40_SECTOR_4_PANCHKULA'| translate}}</span>
            </div>
            <div class="field sm:col-12 md:col-12 lg:col-12 my-1 py-2 mx-2 px-0 footer-info">
                <i class="pi pi-phone footer-icon"></i>
                <span class="footer-text">0172–2562275</span>
            </div>
            <div class="field sm:col-12 md:col-12 lg:col-12 my-1 py-2 mx-2 px-0 footer-info">
                <i class="pi pi-envelope footer-icon"></i>
                <span class="footer-text">{{'EMAIL'| translate}}: cmda@hry.nic.in</span>
            </div>

            <div class="field sm:col-12 md:col-12 lg:col-12 mt-5 py-2 mx-2 px-0 footer-info">
                <span class="footer-text-last-date">{{'LAST_UPDATED_ON'| translate}} {{ lastUpdated | date:'mediumDate'
                    }}</span>
            </div>
        </div>
        <div class="field sm:col-12 md:col-8 lg:col-8 my-0 py-0 mx-0 px-0">
            <div class="py-2 px-2">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3431.003752862236!2d76.8517319!3d30.6901705!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390f93dcb3863f59%3A0xd765a8911cdb34ac!2sMICADA%20Haryana%20Head%20office!5e0!3m2!1sen!2sin!4v1734435581462!5m2!1sen!2sin"
                    width="100%" height="100%" style="border:0;" object-fit="contain" allowfullscreen="true"
                    loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>
    </div>
</div>

<!-- Copyright Section -->
<div class="footer-copyright text-center text-white py-2">
    Copyright © 2021 Micro Irrigation & Command Area Development Authority, Haryana. All Rights Reserved.
</div>